import { useCallback, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useAdminStatus() {
  const [isAdmin, setIsAdmin] = useState(false);

  const fetchAdminStatus = useCallback(async (userId: string) => {
    const { data } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .eq('role', 'admin');

    setIsAdmin(!!data && data.length > 0);
  }, []);

  const reset = useCallback(() => {
    setIsAdmin(false);
  }, []);

  return {
    isAdmin,
    fetchAdminStatus,
    reset,
  };
}
